import Image, { type ImageProps } from 'next/image';
import { memo } from 'react';

import { useCurrentWorkspace } from '~/providers/CurrentWorkspaceProvider';

export type WorkspaceLogoProps = Omit<ImageProps, 'src' | 'alt'>;

export const WorkspaceLogo = memo((props: WorkspaceLogoProps) => {
  const { currentWorkspace } = useCurrentWorkspace();

  if (!currentWorkspace) {
    return null;
  }

  return (
    <Image
      {...props}
      alt={`Logo for ${currentWorkspace?.name}`}
      src={currentWorkspace?.image || ''}
      width={32}
      height={32}
    />
  );
});

WorkspaceLogo.displayName = 'WorkspaceLogo';
